// extracted by mini-css-extract-plugin
export default {"input":"AnswerFeedbackModal_input__zCncN","ratings":"AnswerFeedbackModal_ratings__HBFLG"};